import { graphql } from 'gatsby';
import { ComponentTrustpilot } from '~components/ComponentTrustpilot';
import { Image } from '~components/Image';

import * as styles from './ComponentCoverageLandingHeader.module.css';

import type { UspItem } from './types';

type ComponentCoverageLandingHeaderUspItemProps = {
  content: UspItem;
};

export const ComponentCoverageLandingHeaderUspItem: React.FC<ComponentCoverageLandingHeaderUspItemProps> = ({
  content,
}) => {
  if (content.__typename === 'ContentfulComponentTrustpilot')
    return (
      <div className={styles.uspItemTrustpilot}>
        <ComponentTrustpilot trustpilot={{ template: 'Micro TrustScore' }} />
      </div>
    );

  return (
    <div className={styles.uspItem}>
      <div className={styles.uspItemIconWrapper}>
        <Image image={content.icon} className={styles.uspItemIcon} />
      </div>
      <div className={styles.uspItemLabel}>{content.label}</div>
    </div>
  );
};

export const query = graphql`
  fragment ComponentCoverageLandingHeaderUspItem on ContentfulComponentCoverageLandingHeaderUspItem {
    __typename
    icon {
      ...MixedMedia
    }
    label
  }
`;
